import React from 'react';
import { PDFUIRenderToElementContext } from './FoxitWebPDFContexts';
import './PDFViewerRenderer.css';

export const PDFViewerRenderer = React.memo(function () {
    return <PDFUIRenderToElementContext.Consumer>
        {(ref) => {
            const setRef = (el) => {
                if (el && !ref.current) {
                    console.log('[Foxit] Viewer container mounted', el.getBoundingClientRect());
                }
                if (ref) ref.current = el;
            };
            return <div className="foxit-pdf-viewer-container" ref={setRef}></div>
        }}
    </PDFUIRenderToElementContext.Consumer>
});
